import OrderStatusSettings from './OrderStatusSettings';
import { useParams } from 'react-router-dom';
import OrderAssetStatus from './OrderAssetStatus';
import WorkStatusSettings from './WorkStatusSettings';
export default function Status() {
  const { type } = useParams();
  if (type === 'order') return <OrderStatusSettings />;
  return type === 'work' ? <WorkStatusSettings /> : <OrderAssetStatus />;
}
